(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Eager load first 4 product images
  document.addEventListener('DOMContentLoaded', () => {
    const images = document.querySelectorAll('.product-grid__item img[loading="lazy"]');
    images.forEach((img, i) => {
      if (i < 4) {
        img.loading = 'eager';
        img.fetchPriority = 'high';
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
